import {
  CognitiveDomain,
  Feature,
  PlaylistVoiceMessage,
  VoiceMessage,
} from "types/api";
import { arrayContainsString, stringEquals } from "./string-utils";

export function sortPVMs(
  playlistVoiceMessages: PlaylistVoiceMessage[]
): VoiceMessage[] {
  const pvms = [...playlistVoiceMessages];
  pvms.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const allMessages = pvms
    .map((pvm) => pvm.voiceMessage)
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-extra-boolean-cast
    ?.flatMap((x) => (!!x ? [x] : []));
  return sortVoiceMessages(allMessages);
}

export function sortVoiceMessages(
  voiceMessages: VoiceMessage[]
): VoiceMessage[] {
  const intros = getInstruction(voiceMessages, CognitiveDomain.Intro);

  // Special feedback message to be played after the intro
  const recordingReview = getInstruction(
    voiceMessages,
    CognitiveDomain.RecordingFeedback
  );

  // Get all HBA, Lifestyle, and Compensatory Strategies messages
  const body = voiceMessages.filter(
    (msg) => msg?.feature !== Feature.Instructions
  );

  const outros = getInstruction(voiceMessages, CognitiveDomain.Outro);

  const userFeedback = getInstruction(
    voiceMessages,
    CognitiveDomain.ClientReflection
  );

  // Add messages in their correct sections
  const sortedMessages = [
    ...intros,
    ...recordingReview,
    ...body,
    ...outros,
    ...userFeedback,
  ];

  const uncategorizedMessages = voiceMessages.filter((msg) => {
    return !sortedMessages.includes(msg);
  });

  return [...sortedMessages, ...uncategorizedMessages];
}

function getInstruction(
  fullMessageList: VoiceMessage[],
  cognitiveDomain?: string
): VoiceMessage[] {
  return getMessagesByFeatureAndCognitiveDomain(
    fullMessageList,
    Feature.Instructions,
    cognitiveDomain
  );
}

function getMessagesByFeatureAndCognitiveDomain(
  fullMessageList: VoiceMessage[],
  feature?: string,
  cognitiveDomain?: string
): VoiceMessage[] {
  let messages = [...fullMessageList];

  if (feature) {
    messages = messages.filter((msg) => stringEquals(msg?.feature, feature));
  }

  if (cognitiveDomain) {
    messages = messages.filter((msg) =>
      arrayContainsString(msg?.cognitiveDomains ?? [], cognitiveDomain)
    );
  }

  return messages;
}
